import {get} from "@/services/api";

const state = {
    isLoading: true,
    isLoggedIn: false,
    username: null,
    uisId: null,
    name: null,
    hasGamificationAccess: false
};

const getters = {
    isLoading(state) { return state.isLoading },
    isLoggedIn(state) {
        return state.isLoggedIn;
    },
    username(state) {
        return state.username;
    },
    uisId(state){
        return state.uisId
    },
    name(state){
        return state.name
    },
    hasGamificationAccess(state){
        return state.hasGamificationAccess
    }
};

const actions = {
    // eslint-disable-next-line
    async fetchByLoginOrId({ commit },{xlogin, uisId}){
        const params = []
        if (xlogin) params.push(`xlogin=${xlogin}`)
        if (uisId) params.push(`uisId=${uisId}`)
        const uri = `api/users/search?${params.join('&')}`
        return await get(uri)
    },

    async resolveGamificationAccess({ commit }){
        try {
            await get('gamification/academic/')
            commit('setHasGamificationAccess', true)
        } catch (e) {
            commit('setHasGamificationAccess', false)
        }
    }

};

const mutations = {
    startLoading(state) {
        state.isLoading = true;
    },

    stopLoading(state) {
        state.isLoading = false;
    },

    logIn(state) {
        state.isLoggedIn = true;
    },

    logOut(state) {
        state.isLoggedIn = false;
    },

    setUsername(state, username) {
        state.username = username;
    },
    setUisId(state, uisId){
        state.uisId = uisId
    },
    setName(state, name){
        state.name = name
    },
    setHasGamificationAccess(state, hasAccess){
        state.hasGamificationAccess = hasAccess
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}